import { Injectable, inject } from '@angular/core';
import AngularHelperService from '../services/angular-helper.service';
import AngularRoutingHelperService from '../services/angular-routing-helper.service';

@Injectable({ providedIn: 'root' })
export default class NotificationService {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	
	store: any = {
		isWindowActive: 'EyD66V',
		lastNotificationStores: {
			chat: '3wTcBZ',
			booking: 'j3EDxS',
			instantBooking: 'F8fVcZ',
		},
		titleBlinkingInterval: 1000,
	};
	
	constructor() {
		localStorage.setItem(this.store.isWindowActive, "true");
		
		this.angularHelperService.getWindow().onfocus = () => { localStorage.setItem(this.store.isWindowActive, "true"); };
		this.angularHelperService.getWindow().onblur = () => { localStorage.setItem(this.store.isWindowActive, "false"); };
	}
	
	createNotification(opts) {
		var options: any = {
			body: opts.body,
			icon: opts.img || '/favicon-32x32.png',
			vibrate: [100, 50, 100],
		};
		
		var notification: any = new Notification(opts.title, options);
		
		notification.onclick = (e) => {
			window.focus();
			if (typeof opts.onClick === 'function' 
				&& this.angularRoutingHelperService.getCurrentPath().indexOf('call') === -1) {
				opts.onClick();
			}
		};
		// this.angularHelperService.createTimer(() => { notification.close(); }, 5000);
		
		if (opts.lastId) localStorage.setItem(this.store.lastNotificationStores[opts.type], opts.lastId);
	}
	
	displayPushNotification(opts) {
		if (!opts.type || !opts.lastId || !opts.title || !opts.body || !('Notification' in window)) return;
		var storageObj: any = window.localStorage.getItem(this.store.isWindowActive);
		if (!opts.showAlways && storageObj && JSON.parse(storageObj)) return;
		
		var allowedTypes: any = Object.keys(this.store.lastNotificationStores);
		if (allowedTypes.indexOf(opts.type) === -1) return;
		var theAllowedType: any = window.localStorage.getItem(this.store.lastNotificationStores[opts.type]);
		if (theAllowedType && JSON.parse(theAllowedType) >= opts.lastId) return;
		
		if (Notification.permission === 'granted') {
			this.createNotification(opts);
			return;
		}
		
		if (Notification.permission !== 'denied') {
			Notification.requestPermission((permission) => {
				if (permission === 'granted') {
					this.createNotification(opts);
					return;
				}
			});
		}
	}
	
	displayTitleNotification(count) {
		if (count === this.store.titleNotificationCount) return;
		this.destroyTitleNotification();
		this.updateTitleNotification(count);
	}
	
	updateTitleNotification(count) {
		var title: any = document.title;
		var originalTitle: any = (title.indexOf(')') !== -1) ? title.split(')').slice(-1).pop().trim() : title;
		var notifications: any = count ? '(' + count + ') ' : '';
		this.store.titleNotificationCount = count;
		
		document.title = title === originalTitle ? notifications + originalTitle : originalTitle;
		if (count) this.store.titleBlinkingTimeout = this.angularHelperService.createTimer(() => {
			this.updateTitleNotification(count);
		}, this.store.titleBlinkingInterval);
	}
	
	destroyTitleNotification() {
		if (this.store.titleBlinkingTimeout) this.angularHelperService.cancelTimer(this.store.titleBlinkingTimeout);
	}
	
	requestPermission() {
		if (!('Notification' in window)) return;
		Notification.requestPermission();
	}
	
}